import history from '../../history';
import Promise from 'bluebird';
import axiosInstance from '../utils/axios';
import debug from 'debug';
import {formatBranding} from '../utils/utils';

const log = debug('circleblack:product');

const product = {
  version: process.env.REACT_APP_VERSION,
  brand: {},
};

log('Product Brand', product);

/* --- actions ---*/
const GET_BRAND = 'GET_BRAND';

export const _setBrand = brand => dispatch => dispatch({
  type: GET_BRAND,
  brand: formatBranding(brand),
});

export const _getBrand = () => dispatch => {
  (localStorage.brand ? Promise.resolve(dispatch({type: GET_BRAND, brand: formatBranding(JSON.parse(localStorage.brand))})) : axiosInstance.get(
    '/products/brand',
    {headers: {'cb-origin': window.origin || window.location.origin}}
  )
    .then(function setBrand(res) {
      let brand = formatBranding(res.data);

      localStorage.setItem('brand', JSON.stringify(brand));
      dispatch({
        type: GET_BRAND,
        brand,
      });
    }))
    .catch(function error() {
      history.push('/login');
    });
};

/* --- reducer ---*/
export default function reducer(state = product, action) {
  const newState = {...state};

  switch (action.type) {
    case GET_BRAND:
      newState.brand = action.brand; // TODO Verify branding is working when logging in, may need to swap to it's own reducer
      break;
    default:
      return state;
  }
  return newState;
}
